// Bus simples para acoplar a notificação ao "mover conversa para o topo" da lista.
//
// Motivação: a notificação só deve disparar quando a conversa realmente sobe pro
// topo da lista de conversas — ou seja, quando TODAS as verificações da lista
// (shouldUpdateTicket + filtrarLista) passam. Antes o DesktopNotificationManager
// escutava o socket por conta própria e podia notificar conversas que nem apareciam
// na lista do atendente (filtro de fila/conexão/tempo divergente).
//
// Fluxo:
//   - TicketsList publica (emitTicketMovedToTop) quando moveu a conversa pro topo.
//   - DesktopNotificationManager assina (subscribeTicketMovedToTop) e aplica suas
//     próprias regras (escopo, aceita, som, etc.) antes de exibir.
//
// O payload é o mesmo objeto `data` do evento socket "appMessage"
// ({ action, message, ticket, contact }).

const listeners = new Set();

export const subscribeTicketMovedToTop = (fn) => {
	if (typeof fn !== "function") return () => {};
	listeners.add(fn);
	return () => {
		listeners.delete(fn);
	};
};

export const emitTicketMovedToTop = (data) => {
	listeners.forEach((fn) => {
		try {
			fn(data);
		} catch (_) {
			/* um assinante com erro não pode derrubar os demais */
		}
	});
};
